module.exports = __webpack_public_path__ + "static/img/valuess-03.a7b9df03.png";